'use strict';
require('mailcheck');

var clearErrorOnField = require('./clearErrorOnField');
var showErrorForField = require('./showErrorForField');

function performMailCheckJs ($element) {
  var value = $element.val();
  var $parent = $element.parent();
  var $suggest = $parent.prev().find('.suggest');
  var suggestTextData = $suggest.attr('data-lang') || '';

  // avoid validating crappy e-mails
  if (value.length > 30) {
    return clearErrorOnField($element);
  } else {
    return $element.mailcheck({
      suggested: function (element, suggestion) {
        // find suggestion container
        $suggest.html(
          suggestTextData +
          ' <a href="#" class="mailcheck-suggestion">' +
          suggestion.full +
          '</a> ?'
        );

        showErrorForField($element, 'suggest');

        // bind suggestion click event
        return $suggest.find('a.mailcheck-suggestion')
          .on('click', function (event) {
            var $this = $(this);

            event.preventDefault();
            // replace with corrected content
            $element.val($this.html());
            $this.html('');
            return clearErrorOnField($element);
          });
      },
      empty: function () {
        return clearErrorOnField($element);
      }
    });
  }
}

module.exports = performMailCheckJs;
